import React from 'react'
import { SvgIcon } from '@material-ui/core'

function NextIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Vector 5'
        d='M9.5 6L14.5 12.3158L9.5 18'
        fill='none'
        stroke='#444444'
        stroke-width='1.8'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </SvgIcon>
  )
}

export default NextIcon
